import ProductTag from '@pages/ProductListing/view/components/ProductTag'
import React, { useState } from 'react'
import { inrFormat } from '@common/utils/formatCurrency';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import ProgressTracker from '../ProgressTracker';
import {
    Modal, Box, TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

function OrderCard({ status, orderDetails }) {

    const handleBackdropClick = (event) => {
        // Prevent close when the backdrop is clicked
        event.stopPropagation();
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleModalClose = (event, reason) => {
        // This is where you can handle close when clicking the modal button, etc.
        if (reason === 'backdropClick') {
            // Do nothing to prevent closing on backdrop click
            return;
        }
        handleClose();
    };



    const cld = new Cloudinary({
        cloud: {
            cloudName: 'dci1aiukm'
        }
    });

    const myImage = cld.image('P0037-AMORIA-LIGHT_SILVER_-1').quality('auto').delivery(format('webp'));

    //state dropdown
    const [state, setState] = useState('');

    const stateHandleChange = (event) => {
        setState(event.target.value);
    };

    return (
        <>
            <div className='bs-order-card'>
                <div className='bs-order-card__head-wrap'>
                    {(status.toLowerCase() === 'pending' || status.toLowerCase() === 'created' || status.toLowerCase() === 'ready_to_ship' || status.toLowerCase() === 'processing' || status.toUpperCase() === 'DISPATCHED') &&
                        <div className='bs-order-card__title-wrap'>
                            <h2 className='bs-order-card__title'>
                                <span className='bs-order-card__title-text'>{status}</span>
                            </h2>
                            <ProgressTracker />
                        </div>
                    }
                    {(status.toLowerCase() === 'delivered') &&
                        <div className='bs-order-card__title-wrap'>
                            <h2 className='bs-order-card__title'>
                                <span className='icon icon-check-circle bs-order-card__icon'></span>
                                <span className='bs-order-card__title-text'>{status}</span>
                            </h2>
                        </div>
                    }
                    {status.toLowerCase() === 'cancelled' &&
                        <div className='bs-order-card__title-wrap'>
                            <h2 className='bs-order-card__title'>
                                <span className='icon icon-forbidden bs-order-card__icon'></span>
                                <span className='bs-order-card__title-text'>order cancelled</span>
                            </h2>
                        </div>
                    }
                    {status === 'cancelled' ? null :
                        <div className='bs-order-card__action-wrap'>
                            <ul className='bs-order-card__action-list'>
                                {(status === 'pending' || status.toLowerCase() === 'created' || status.toLowerCase() === 'ready_to_ship' || status.toLowerCase() === 'complete') &&
                                    <li className='bs-order-card__action-item'>
                                        <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button' onClick={handleOpen}>
                                            <span className='bs-btn__btn-text'>cancel order</span>
                                        </button>
                                    </li>
                                }
                                {(status === 'delivered') &&
                                    <li className='bs-order-card__action-item'>
                                        <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button'>
                                            <span className='bs-btn__btn-text'>return/replace</span>
                                        </button>
                                    </li>
                                }
                                {(status.toUpperCase() === 'DISPATCHED' || status.toUpperCase() === 'DELIVERED') &&
                                    <li className='bs-order-card__action-item'>
                                        {/* <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button'>
                                        <span className='icon icon-invoice-download bs-btn__icon'></span>
                                        <span className='bs-btn__btn-text'>download invoice</span>
                                    </button> */}
                                        <a href={orderDetails?.invoiceUrl} rel="noreferrer" target='_blank' className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button'>
                                            <span className='icon icon-invoice-download bs-btn__icon'></span>
                                            <span className='bs-btn__btn-text'>download invoice</span>
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
                <div className='bs-order-card__info-wrap'>
                    <div className='bs-order-card__order-info-wrap'>
                        <ul className='bs-order-card__order-info-data-wrap'>
                            <li className='bs-order-card__order-info-data-item'>
                                <label className='bs-order-card__order-info-data-label'>order id :</label>
                                <p className='bs-order-card__order-info-data-value'>{orderDetails?.id}</p>
                            </li>
                            <li className='bs-order-card__order-info-data-item'>
                                <label className='bs-order-card__order-info-data-label'>placed on :</label>
                                <p className='bs-order-card__order-info-data-value'>{orderDetails?.orderDate.split("T")[0]}</p>
                            </li>
                            <li className='bs-order-card__order-info-data-item'>
                                <label className='bs-order-card__order-info-data-label'>order total :</label>
                                <p className='bs-order-card__order-info-data-value'>{inrFormat(orderDetails?.orderAmount)}</p>
                            </li>
                            {
                                orderDetails?.trackingNumber && 
                                (<li className='bs-order-card__order-info-data-item'>
                                    <label className='bs-order-card__order-info-data-label'>Tracking number : Delhivery - </label>
                                    <p className='bs-order-card__order-info-data-value'>{orderDetails?.trackingNumber}</p>
                                </li>)
                            }
                        </ul>
                    </div>
                    <div className={`bs-order-card__product-info-wrap ${status === 'cancelled' ? 'bs-order-card__product-info-wrap--no-bottom-border' : ''}`}>
                        <ul className='bs-order-card__product-list'>
                            {orderDetails?.orderItem?.map((item, index) => {
                                return (
                                    <li className='bs-order-card__product-item'>
                                        <div className='bs-order-card__product'>
                                            <div className='bs-order-card__product-media-wrap'>
                                                <AdvancedImage cldImg={cld.image(item.product.imageUrl).quality('auto').delivery(format('webp'))} loading="lazy" className='bs-order-card__product-image' />
                                            </div>
                                            <div className='bs-order-card__product-detail-wrap'>
                                                <label className='bs-order-card__product-type'>{item?.product?.sapCategoryName}</label>
                                                <h3 className='bs-order-card__product-title'>{item?.product?.name}</h3>
                                                <p className='bs-order-card__product-size-info'><span className='bs-order-card__product-size-info--bold'>size : </span>{item?.product?.size} {item?.product?.dimensions}</p>
                                                <p className='bs-order-card__product-size-info'><span className='bs-order-card__product-size-info--bold'>quantity : </span>{item?.quantity}</p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })}
                            {/* <li className='bs-order-card__product-item'>
                            <div className='bs-order-card__product'>
                                <div className='bs-order-card__product-media-wrap'>
                                    <AdvancedImage cldImg={myImage} loading="lazy" className='bs-order-card__product-image'/>
                                </div>
                                <div className='bs-order-card__product-detail-wrap'>
                                    <label className='bs-order-card__product-type'>bedsheet set</label>
                                    <h3 className='bs-order-card__product-title'>Melange luxe Pillow Covers</h3>
                                    <p className='bs-order-card__product-size-info'><span className='bs-order-card__product-size-info--bold'>size : </span>Single w 75 x L 100 in Inches</p>
                                </div>
                            </div>
                        </li>
                         <li className='bs-order-card__product-item'>
                            <div className='bs-order-card__product'>
                                <div className='bs-order-card__product-media-wrap'>
                                    <AdvancedImage cldImg={myImage} loading="lazy" className='bs-order-card__product-image'/>
                                </div>
                                <div className='bs-order-card__product-detail-wrap'>
                                    <label className='bs-order-card__product-type'>bedsheet set</label>
                                    <h3 className='bs-order-card__product-title'>Melange luxe Pillow Covers</h3>
                                    <p className='bs-order-card__product-size-info'><span className='bs-order-card__product-size-info--bold'>size : </span>Single w 75 x L 100 in Inches</p>
                                </div>
                            </div>
                        </li>
                        <li className='bs-order-card__product-item'>
                            <div className='bs-order-card__product'>
                                <div className='bs-order-card__product-media-wrap'>
                                    <AdvancedImage cldImg={myImage} loading="lazy" className='bs-order-card__product-image'/>
                                </div>
                                <div className='bs-order-card__product-detail-wrap'>
                                    <label className='bs-order-card__product-type'>bedsheet set</label>
                                    <h3 className='bs-order-card__product-title'>Melange luxe Pillow Covers</h3>
                                    <p className='bs-order-card__product-size-info'><span className='bs-order-card__product-size-info--bold'>size : </span>Single w 75 x L 100 in Inches</p>
                                </div>
                            </div>
                        </li> */}
                        </ul>
                    </div>
                </div>
                {status === 'cancelled' ? null :
                    <div className='bs-order-card__address-wrap'>
                        <label className='bs-order-card__address-wrap-title'>delivering to</label>
                        <div className='bs-order-card__cont-wrap'>
                            <div className='bs-order-card__address-title-wrap'>
                                <strong className='bs-order-card__address-title'>{orderDetails?.shippingAddress?.firstName} {orderDetails?.shippingAddress?.lastName}</strong>
                                <ProductTag title={orderDetails?.shippingAddress?.tag} classname="mod-product-tag--typ-border" />
                            </div>
                            <address className='bs-order-card__address-text'>{orderDetails?.shippingAddress?.address} {orderDetails?.shippingAddress?.city} - {orderDetails?.shippingAddress?.state} - {orderDetails?.shippingAddress?.pincode}</address>
                        </div>
                    </div>
                }
            </div>
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-select-address'

            >
                <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
                    <button className='bs-modal__close  bs-banner-form__close-btn' onClick={handleModalClose}>
                        <span className='icon icon-simple-close'></span>
                    </button>
                    <div className="bs-success-msg">
                        <div className='bs-success-msg__info-wrap'>
                            {/* <span className='icon icon-success bs-success-msg__icon'></span> */}
                            {/* <h4 className='bs-success-msg__title'>Order placed successfully</h4> */}
                            <p className='bs-success-msg__desc'>
                                Returns and Replacements are available for damaged products or manufacturing defects within 7 days of delivery.
                                Order cancellations are applicable only for orders that are not dispatched.
                                Write to us at <a href="mailto:support@sansaar.co.in" className="bs-link">support@sansaar.co.in</a>&nbsp;
                                or call our customer care at <a href="tel:+918655712561" className="bs-link">+91 8655712561</a>&nbsp;
                                for any return, refund, or cancellation requests.
                            </p>
                        </div>
                        {/* <div className='bs-success-msg__action-wrap'>
                        <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={handleModalClose}>continue shopping</button>
                    </div> */}
                    </div>
                </Box>
            </Modal>

            {/* <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='bs-modal bs-modal--typ-form bs-modal--typ-order-cancel'
            
        >
            <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
                <div className='bs-modal__content'>
                    <h2 className='bs-modal__title'>Forgot password</h2>
                    <p className='bs-modal__title-desc'>
                        Returns and Replacements are available for damaged products or manufacturing defects within 7 days of delivery. 
                        Order cancellations are applicable only for orders that are not dispatched. 
                        Write to us at <a href="mailto:support@sansaar.co.in" className="bs-link">support@sansaar.co.in</a> 
                        or call our customer care at <a href="tel:+918655712561" className="bs-link">+91 8655712561</a> 
                        for any return, refund, or cancellation requests.
                    </p>
                    <form className='bs-form bs-form--typ-column'>
                        <div className={`bs-form__form-group`}>
                            <TextField
                            id="emailId"
                            name="emailId"
                            // value={signInFormik.values.username}
                            // onChange={signInFormik.handleChange}
                            // onBlur={signInFormik.handleBlur}
                            type="email"
                            label="Email Id"
                            className='bs-form__form-control'
                            />
                        </div>
                        <div className={`bs-form__form-bottom-wrap`}>
                            <div className='bs-form__form-bottom-wrap--col'>
                            <button 
                                className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl'
                                onClick={successHandleModalOpen}
                            >
                                Send resend link
                            </button>
                            </div>
                            <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={hideForgotPassWordFormHandle}>back to sign in</button>
                        </div>
                    </form>
                </div>
                <div className='bs-modal__content'>
                    <div className='bs-cancel-order'>
                        <div className='bs-cancel-order__head-wrap'>
                            <span className='bs-cancel-order__icon icon icon-forbidden'></span>
                            <h3 className='bs-cancel-order__title'>Are you sure you want to cancel selected order ?</h3>
                            <label className='bs-cancel-order__order-info'><span className='bs-cancel-order__order-info--bold'>order id :</span>121435195150135</label>
                        </div>
                        <form className='bs-form bs-form--typ-column bs-cancel-order__cont-wrap'>
                            <div className={`bs-form__form-group`}>
                                <div className={`bs-form__form-group`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label" required>select reason</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={state}
                                            label="select reason"
                                            onChange={stateHandleChange}
                                            // IconComponent={<span className='icon icon-expaand-more'></span>}
                                        >
                                            <MenuItem value={10}>Ten</MenuItem>
                                            <MenuItem value={20}>Twenty</MenuItem>
                                            <MenuItem value={30}>Thirty</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className={`bs-form__form-group`}>
                                <TextField 
                                    id="comments"
                                    name="comments"
                                    type="text"
                                    label="add comments" 
                                    className='bs-form__form-control bs-form__form-control--text-area' 
                                    multiline
                                    maxRows={5}
                                />
                            </div>
                            <div className={`bs-form__form-bottom-wrap`}>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' type='submit' >yes, cancel</button>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border'>go back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Box>
        </Modal> */}
        </>
    )
}

export default OrderCard